import { Tooltip } from "bootstrap";
import AccessPointSearch from "./access_point_search";
import AutoSizer from "./auto_sizer";
import LiveValidator from "./live_validator";
import SelectTag from "./select_tag";
import WordCounter from "./word_counter";
import Lightbox from "./lightbox";
import IndeterminateCheckboxes from "./indeterminate_checkboxes";
import SearchBar from "./search";
import MultiSelectTag from "./multi_select_tag";
import SearchSelect from "./search_select";
import Pagination from "./pagination";
import PasswordInput from "./password_input";
import PasswordStrength from "./password_strength";
import PasswordMatch from "./password_match";
import ImageCropper from "./image_cropper";
import CopyLink from "./copy_link";
import AjaxForm from "./ajax_form";
import ConfirmationModal from "./confirmation_modal";
import DatePicker from "./datepicker";
import ProductFilter from "./product_filter";
import WebsiteGenerator from "./website_generator";
import CollapsibleContent from "./collapsible_content";
import CollapsibleFilterGroup from "./collapsible_filter_group";
import CollapsibleShowMore from "./collapsible_show_more";
import SocialMediaCreator from "./social_media_creator";
import SelectTagWithCollapsibleContent from "./select_tag_with_collapsible_content";
import CheckboxRadio from "./checkbox_radio";
import Livestream from "./livestream";
import DoughnutChart from "./doughnut_chart";
import DashboardFilter from "./dashboard_filter";
import RegionSelect from "./region_select";
import AddressAutocomplete from "./address_autocomplete";
import CheckboxUnchecked from "./checkbox_unchecked";
import ShowMore from "./show_more";
import Qv from "./qv";
import QvInformational from "./qv_informational";
import Focus from "./focus";
import InstantModal from "./instant_modal";
import Review from "./review";
import DownloadModal from "./download_modal";
import SelectTagWithLinkChange from "./select_tag_with_link_change";
import SidebarFilter from "./sidebar_filter";
import CheckboxForm from "./checkbox_form";
import ReadMore from "./read_more";
import ScrollArrows from "./scroll_arrows";
import FileUploader from "./file_uploader";
import ScrollSpy from "./scroll_spy";
import InfiniteScroll from "./infinite_scroll";
import ClickableTableRow from "./clickable_table_row";
import CustomScroll from "./custom_scroll";
import SortableColumn from "./sortable_column";
import Autocomplete from "./autocomplete";
import AutocompleteSearch from "./autocomplete_search";
import AddToCartBundleSimplified from "./add_to_cart_bundle_simplified";
import AddToCartProductPage from "./add_to_cart_product_page";
import AddToCartOnce from "./add_to_cart_once";
import AddToCart from "./add_to_cart";
import AutocompleteGoogle from "./autocomplete_google";
import BadgeModal from "./badge_modal";
import Recorder from "./recorder";

export default class Beyuna {
  constructor() {
    this.classes = {};
    this.objects = {};

    this.loadClasses();
    this.checkContrast();

    this.clickCount = 0;
    this.timeout;
  }

  // TODO: will have to re-implement this with session cookie from back-end.

  checkContrast() {
    const theme = localStorage.getItem("theme") || "light";
    const contrastToggle = document.querySelector(".js-contrast-button");
    const contrastCheckbox = document.querySelector(".js-contrast-checkbox");
    const logoImages = document.querySelectorAll(".js-logo");

    document.documentElement.dataset.bsTheme = theme;

    logoImages.forEach((logoImage) => {
      const src = logoImage.src;

      if ((src.includes("contrast") && theme === "contrast") || (src.includes("light") && theme === "light")) {
        return;
      } else {
        logoImage.src = src.includes("light") ? src.replace("light", "contrast") : src.replace("contrast", "light");
      }
    });

    if (contrastToggle) {
      contrastCheckbox.checked = theme === "contrast";

      contrastToggle.addEventListener("click", () => {
        this.clickCount++;

        if (this.clickCount === 5) {
          window.dispatchEvent(new Event("contrast-party"));
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.clickCount = 0;
        }, 250);

        document.documentElement.dataset.bsTheme = document.documentElement.dataset.bsTheme === "contrast" ? "light" : "contrast";
        localStorage.setItem("theme", document.documentElement.dataset.bsTheme);
        contrastToggle.classList.toggle("active");

        logoImages.forEach((logoImage) => {
          const src = logoImage.src;
          const newSrc = src.includes("light") ? src.replace("light", "contrast") : src.replace("contrast", "light");
          logoImage.src = newSrc;
        });

        window.dispatchEvent(new Event("contrast-toggled"));
      });
    }
  }

  loadClasses() {
    this.classes["ups-access-point"] = {
      class: AccessPointSearch,
      priority: 0,
    };
    this.classes["custom-select"] = {
      class: SelectTag,
      priority: 0,
    };
    this.classes["custom-select-with-collapsible-content"] = {
      class: SelectTagWithCollapsibleContent,
      priority: 0,
    };
    this.classes["custom-multi-select"] = {
      class: MultiSelectTag,
      priority: 0,
    };
    this.classes["live-validator"] = {
      class: LiveValidator,
      priority: 0,
    };
    this.classes["word-counter"] = {
      class: WordCounter,
      priority: 0,
    };
    this.classes["auto-sizer"] = {
      class: AutoSizer,
      priority: 0,
    };
    this.classes["lightbox"] = {
      class: Lightbox,
      priority: 0,
    };
    this.classes["indeterminate-checkboxes"] = {
      class: IndeterminateCheckboxes,
      priority: 0,
    };
    this.classes["search"] = {
      class: SearchBar,
      priority: 0,
    };
    this.classes["personal-orders"] = {
      class: SearchSelect,
      priority: 0,
    };
    this.classes["pagination"] = {
      class: Pagination,
      priority: 0,
    };
    this.classes["password"] = {
      class: PasswordInput,
      priority: 0,
    };
    this.classes["password-strength"] = {
      class: PasswordStrength,
      priority: 0,
    };
    this.classes["password-match"] = {
      class: PasswordMatch,
      priority: 0,
    };
    this.classes["image-cropper"] = {
      class: ImageCropper,
      priority: 0,
    };
    this.classes["copy-link"] = {
      class: CopyLink,
      priority: 0,
    };
    this.classes["live-validator"] = {
      class: LiveValidator,
      priority: 0,
    };
    this.classes["add-to-cart"] = {
      class: AddToCart,
      priority: 0,
    };
    this.classes["add-to-cart-once"] = {
      class: AddToCartOnce,
      priority: 0,
    };
    this.classes["add-to-cart-product-page"] = {
      class: AddToCartProductPage,
      priority: 0,
    };
    this.classes["add-to-cart-bundle-simplified"] = {
      class: AddToCartBundleSimplified,
      priority: 0,
    };
    this.classes["ajax-form"] = {
      class: AjaxForm,
      priority: 0,
    };
    this.classes["confirmation-modal"] = {
      class: ConfirmationModal,
      priority: 0,
    };
    this.classes["datepicker"] = {
      class: DatePicker,
      priority: 0,
    };
    this.classes["product-filter"] = {
      class: ProductFilter,
      priority: 0,
    };
    this.classes["website-generator"] = {
      class: WebsiteGenerator,
      priority: 0,
    };
    this.classes["collapsible-content"] = {
      class: CollapsibleContent,
      priority: 0,
    };
    this.classes["collapsible-filter-group"] = {
      class: CollapsibleFilterGroup,
      priority: 1,
    };
    this.classes["collapsible-show-more"] = {
      class: CollapsibleShowMore,
      priority: 0,
    };
    this.classes["tooltip"] = {
      class: Tooltip,
      priority: 0,
    };
    this.classes["social-media-creator"] = {
      class: SocialMediaCreator,
      priority: 0,
    };
    this.classes["checkbox-radio"] = {
      class: CheckboxRadio,
      priority: 0,
    };
    this.classes["livestream"] = {
      class: Livestream,
      priority: 0,
    };
    this.classes["doughnut-chart"] = {
      class: DoughnutChart,
      priority: 0,
    };
    this.classes["dashboard-filter"] = {
      class: DashboardFilter,
      priority: 0,
    };
    this.classes["region-select"] = {
      class: RegionSelect,
      priority: 0,
    };
    this.classes["autocomplete"] = {
      class: Autocomplete,
      priority: 0,
    };
    this.classes["autocomplete-search"] = {
      class: AutocompleteSearch,
      priority: 0,
    };
    this.classes["autocomplete-google"] = {
      class: AutocompleteGoogle,
      priority: 0,
    };
    this.classes["address-autocomplete"] = {
      class: AddressAutocomplete,
      priority: 0,
    };
    this.classes["checkbox-unchecked"] = {
      class: CheckboxUnchecked,
      priority: 0,
    };
    this.classes["show-more"] = {
      class: ShowMore,
      priority: 0,
    };
    this.classes["qv"] = {
      class: Qv,
      priority: 0,
    };
    this.classes["qv-informational"] = {
      class: QvInformational,
      priority: 0,
    };
    this.classes["focus"] = {
      class: Focus,
      priority: 0,
    };
    this.classes["instant-modal"] = {
      class: InstantModal,
      priority: 0,
    };
    this.classes["review"] = {
      class: Review,
      priority: 0,
    };
    this.classes["download-modal"] = {
      class: DownloadModal,
      priority: 0,
    };
    this.classes["custom-select-with-link-change"] = {
      class: SelectTagWithLinkChange,
      priority: 0,
    };
    this.classes["sidebar-filter"] = {
      class: SidebarFilter,
      priority: 0,
    };
    this.classes["checkbox-form"] = {
      class: CheckboxForm,
      priority: 0,
    };
    this.classes["read-more"] = {
      class: ReadMore,
      priority: 0,
    };
    this.classes["scroll-arrows"] = {
      class: ScrollArrows,
      priority: 0,
    };
    this.classes["file-uploader"] = {
      class: FileUploader,
      priority: 0,
    };
    this.classes["scroll-spy"] = {
      class: ScrollSpy,
      priority: 0,
    };
    this.classes["infinite-scroll"] = {
      class: InfiniteScroll,
      priority: 0,
    };
    this.classes["clickable-table-row"] = {
      class: ClickableTableRow,
      priority: 0,
    };
    this.classes["custom-scroll"] = {
      class: CustomScroll,
      priority: 0,
    };
    this.classes["sortable-column"] = {
      class: SortableColumn,
      priority: 0,
    };
    this.classes["badge-modal"] = {
      class: BadgeModal,
      priority: 0,
    };
    this.classes["recorder"] = {
      class: Recorder,
      priority: 0,
    };

    this.initClasses(document);
  }

  initClasses(scope) {
    const items = scope.querySelectorAll("[data-js-class]");
    const array = Array.from(items).map((item) => item.dataset.jsClass);
    const uniqueClasses = array.filter((value, index, array) => array.indexOf(value) === index);

    const prioritedUniqueClasses = uniqueClasses.sort((a, b) => {
      return this.classes[b].priority - this.classes[a].priority;
    });

    prioritedUniqueClasses.forEach((uniqueClass) => {
      const nodes = scope.querySelectorAll(`[data-js-class='${uniqueClass}']`);

      nodes.forEach((node) => {
        const object = new this.classes[uniqueClass].class(node);

        if (!node.dataset.objectId) {
          return;
        }

        if (this.objects[uniqueClass] === undefined) {
          this.objects[uniqueClass] = [];
        }
        const id = node.dataset.objectId;

        this.objects[uniqueClass][id] = object;
      });
    });

    window.Beyuna = this; // We update the global Beyuna object with the new objects.
    window.dispatchEvent(new Event("beyuna-classes-initialized"));
  }
}
